import { ICSSInJSStyle, pxToRem } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../../../src/shared/theme/useColorScheme";
import { usePlatformTypeContext } from "../../platform-type-provider/PlatformTypeProvider";

interface AudioTestEndedWorkingStyles {
  container: ICSSInJSStyle;
  headerContainer: ICSSInJSStyle;
  runTestAgain: ICSSInJSStyle;
  clarityHeader: ICSSInJSStyle;
  finishPromptHeader: ICSSInJSStyle;
  finish: ICSSInJSStyle;
  testClarityPromptButton: ICSSInJSStyle;
  description: ICSSInJSStyle;
  buttonGroup: ICSSInJSStyle;
  buttonGroupFinish: ICSSInJSStyle;
}

export const useAudioTestEndedWorkingStyles: () => AudioTestEndedWorkingStyles =
  () => {
    const screenHeight = document.documentElement.clientHeight;
    const { main, brand, white } = useFluentColorScheme();
    const { isMobile } = usePlatformTypeContext();
    if (isMobile) {
      return {
        container: {
          background: main.background2,
          position: "relative",
          width: "100%",
          minHeight: screenHeight + "px",
          justifyContent: "center",
        },
        headerContainer: {
          position: "absolute",
          top: "325px",
        },
        clarityHeader: {
          position: "static",
          width: "237px",
          height: "100%",
          color: white.foreground,
          backgroundColor: "transparent",
        },
        finishPromptHeader: {
          position: "static",
          width: "321px",
          height: "100%",
          color: white.foreground,
          backgroundColor: "transparent",
        },
        description: {
          position: "static",
          width: "321px",
          height: "100%",
          color: white.foreground,
          backgroundColor: "transparent",
        },
        testClarityPromptButton: {
          width: "342px",
          color: white.foreground,
          borderRadius: "8px",
          padding: pxToRem(10),
          height: "52px",
          backgroundColor: brand.background,
          border: "none",
        },
        finish: {
          width: "342px",
          color: white.foreground,
          borderRadius: "8px",
          padding: pxToRem(10),
          height: "52px",
          backgroundColor: brand.background,
          border: "none",
        },
        runTestAgain: {
          width: "342px",
          color: white.foreground,
          borderRadius: "8px",
          padding: pxToRem(10),
          height: "52px",
          backgroundColor: "transparent",
          border: `1px solid ${brand.border}`,
        },
        buttonGroup: {
          position: "absolute",
          bottom: "60px",
        },
        buttonGroupFinish: {
          position: "absolute",
          bottom: "60px",
        },
      };
    } else {
      return {
        container: {
          width: "100%",
          height: "100%",
          backgroundColor: main.background,
          overflow: "hidden",
        },
        headerContainer: {
          position: "absolute",
          top: "190px",
        },
        clarityHeader: {
          position: "static",
          maxWidth: "500px",
          color: white.foreground,
          backgroundColor: "transparent",
        },
        finishPromptHeader: {
          position: "static",
          maxWidth: "500px",
          color: white.foreground,
          backgroundColor: "transparent",
        },
        description: {
          position: "static",
          maxWidth: "500px",
          height: "100%",
          color: white.foreground,
          backgroundColor: "transparent",
        },
        testClarityPromptButton: {
          width: "342px",
          color: white.foreground,
          borderRadius: "8px",
          padding: pxToRem(10),
          height: "52px",
          backgroundColor: brand.background,
          border: "none",
        },
        finish: {
          width: "342px",
          color: white.foreground,
          borderRadius: "8px",
          padding: pxToRem(10),
          height: "52px",
          backgroundColor: brand.background,
          border: "none",
        },
        runTestAgain: {
          width: "342px",
          color: white.foreground,
          borderRadius: "8px",
          padding: pxToRem(10),
          height: "52px",
          backgroundColor: "transparent",
          border: `1px solid ${brand.border}`,
        },
        buttonGroup: {
          position: "absolute",
          bottom: "60px",
        },
        buttonGroupFinish: {
          position: "absolute",
          bottom: "60px",
        },
      };
    }
  };
